//#region src/lib/lastFocusableElement.ts
var e = (e) => {
	let t = e.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])");
	return t[t.length - 1];
}, t = class extends HTMLElement {
	static {
		this.EXIT_TIMEOUT = 100;
	}
	constructor() {
		super(), this.activeElement = void 0, this.menus = this.querySelectorAll("[menu]"), this.menuTriggers = this.querySelectorAll("[menu-trigger]"), this._handlePointerEnter = this._handlePointerEnter.bind(this), this._handlePointerOut = this._handlePointerOut.bind(this), this._handleMenuPointerEnter = this._handleMenuPointerEnter.bind(this), this._handleMenuPointerOut = this._handleMenuPointerOut.bind(this), this._handleButtonKeyDown = this._handleButtonKeyDown.bind(this), this._handleMenuCloseKeyDown = this._handleMenuCloseKeyDown.bind(this), this._handleMenuFocusOut = this._handleMenuFocusOut.bind(this), this._handleClick = this._handleClick.bind(this), this.startExitTimer = this.startExitTimer.bind(this), this.stopExitTimer = this.stopExitTimer.bind(this), this.activateMenuWithControl = this.activateMenuWithControl.bind(this);
	}
	get ctor() {
		return this.constructor;
	}
	connectedCallback() {
		Array.from(this.menuTriggers).forEach((e) => {
			e.addEventListener("pointerover", this._handlePointerEnter), e.addEventListener("pointerout", this._handlePointerOut), e.addEventListener("keydown", this._handleButtonKeyDown), e.hasAttribute("aria-controls") && e.addEventListener("click", this._handleClick);
		}), Array.from(this.menus).forEach((t) => {
			t.addEventListener("pointerover", this._handleMenuPointerEnter), t.addEventListener("pointerout", this._handleMenuPointerOut), t.addEventListener("keydown", this._handleMenuCloseKeyDown), e(t)?.addEventListener("keydown", this._handleMenuFocusOut);
		});
	}
	_handleClick(e) {
		let t = e.currentTarget;
		e.preventDefault(), this.activeElement === t ? this.setActiveElement(void 0) : this._handleActivateButton(t);
	}
	_handleActivateButton(e) {
		e.getAttribute("aria-controls") || e.hasAttribute("data-controls") ? (this.stopExitTimer(), this.setActiveElement(e)) : this.setActiveElement(void 0);
	}
	_handleButtonKeyDown(e) {
		let t = e.currentTarget;
		if (e.key === "Enter" || e.key === " ") if (e.preventDefault(), this.activeElement === t) if (t.tagName.toLowerCase() === "a" && t.hasAttribute("href")) {
			let e = t.getAttribute("href");
			e && (window.location.href = e);
		} else t.click();
		else this._handleActivateButton(t);
		else e.key === "Escape" && (e.preventDefault(), this.setActiveElement(void 0), t.focus());
	}
	_handleMenuCloseKeyDown(e) {
		e.key === "Escape" && (e.preventDefault(), this.setActiveElement(void 0), Array.from(this.menuTriggers).find((e) => e.getAttribute("aria-expanded") === "true")?.focus());
	}
	_handleMenuFocusOut(e) {
		e.key === "Tab" && !e.shiftKey && this.startExitTimer();
	}
	_handlePointerEnter(e) {
		let t = e.currentTarget;
		this._handleActivateButton(t);
	}
	_handlePointerOut(e) {
		let t = e.currentTarget;
		this.activeElement === t && this.startExitTimer();
	}
	_handleMenuPointerEnter() {
		this.stopExitTimer();
	}
	_handleMenuPointerOut() {
		this.startExitTimer();
	}
	startExitTimer() {
		this.exitTimer = window.setTimeout(() => {
			this.setActiveElement(void 0);
		}, this.ctor.EXIT_TIMEOUT);
	}
	stopExitTimer() {
		this.exitTimer && window.clearTimeout(this.exitTimer);
	}
	setActiveElement(e) {
		if (this.activeElement !== e) if (this.activeElement = e, this.activateMenuWithControl(this.activeElement), this._handleMenuDrawerARIATags(), this.dataset.state = this.activeElement ? "active" : "inactive", this.activeElement) {
			let e = this.activeElement.getAttribute("aria-controls") || this.activeElement.getAttribute("data-controls"), t = this.querySelector(`#${e}`);
			if (t) {
				let e = t.getBoundingClientRect().height;
				this.style.setProperty("--mega-menu-height", `${e}px`);
			} else this.style.setProperty("--mega-menu-height", "10px");
		} else this.style.setProperty("--mega-menu-height", "0px");
	}
	activateMenuWithControl(e) {
		for (let t of Array.from(this.menuTriggers)) {
			let n = t.getAttribute("aria-controls"), r = t.getAttribute("data-controls");
			(n || r) && t === e ? t.setAttribute("aria-expanded", "true") : t.setAttribute("aria-expanded", "false");
		}
	}
	_handleMenuDrawerARIATags() {
		for (let e of Array.from(this.menus)) {
			if (!this.activeElement) {
				e.setAttribute("aria-hidden", "true");
				continue;
			}
			let t = this.activeElement.getAttribute("aria-controls") || this.activeElement.getAttribute("data-controls");
			e.id === t ? e.setAttribute("aria-hidden", "false") : e.setAttribute("aria-hidden", "true");
		}
	}
};
window.customElements.get("mega-menu") || window.customElements.define("mega-menu", t);
//#endregion
//#region src/entry/main-header.ts
var n = class extends HTMLElement {
	#e;
	static {
		this.observedAttributes = ["data-scroll-direction", "is-sticky"];
	}
	constructor() {
		super(), this.lastScrollY = window.scrollY, this.lastPageHeight = document.documentElement.scrollHeight, this.#e = new ResizeObserver(() => this.#t()), this.hasStickyEnabled = !0, this.hasStickyEnabled = this.getAttribute("is-sticky") === "true";
	}
	connectedCallback() {
		this.#t(), this.#e.observe(this), this.setUpFoldObserver(), this.hasStickyEnabled && (this.timeInterval = setInterval(() => {
			this.setNewScrollValue(window.scrollY);
		}, 150));
	}
	setUpFoldObserver() {
		let e = new IntersectionObserver((t) => {
			t.forEach((t) => {
				t.isIntersecting || (document.body.setAttribute("data-below-fold", "true"), this.dispatchEvent(new CustomEvent("header:below-fold", { bubbles: !0 })), e.disconnect());
			});
		}, {
			root: null,
			threshold: .1
		});
		e.observe(this);
	}
	get scrollDirection() {
		return parseInt(this.getAttribute("data-scroll-direction") || "0", 10);
	}
	attributeChangedCallback(e, t) {
		e === "data-scroll-direction" && (parseInt(t, 10) === 0 && this.scrollDirection === 1 ? this.classList.add("opacity-0") : this.classList.remove("opacity-0"), this.#t());
	}
	#t() {
		let e = this.clientHeight, t = this.querySelector(".shopify-section-main-header .header-internal-wrapper"), n = this.querySelector("[data-header-col-1]");
		if (document.documentElement.style.setProperty("--header-height-actual", `${e}px`), this.isSticky ? t && document.documentElement.style.setProperty("--header-height", `${t.clientHeight}px`) : document.documentElement.style.setProperty("--header-height", "0px"), n) {
			let e = n.querySelectorAll("div[data-logo]");
			n.clientWidth > 271 ? e.forEach((e, t) => {
				t < 2 ? e.classList.remove("hidden") : e.classList.add("hidden");
			}) : n.clientWidth > 149 ? e.forEach((e, t) => {
				t < 1 ? e.classList.remove("hidden") : e.classList.add("hidden");
			}) : e.forEach((e) => {
				e.classList.add("hidden");
			});
		}
	}
	get isSticky() {
		return this.scrollDirection === -1 && this.hasStickyEnabled;
	}
	disconnectedCallback() {
		this.#e.disconnect();
	}
	setScrollDirection(e) {
		this.setAttribute("data-scroll-direction", e.toString());
	}
	setNewScrollValue(e) {
		if (this.lastPageHeight !== document.documentElement.scrollHeight) {
			this.lastScrollY = e, this.lastPageHeight = document.documentElement.scrollHeight;
			return;
		}
		let t = this.clientHeight + 600, n = this.clientHeight + 800;
		if (this.scrollDirection === 0 && e <= n) {
			this.lastScrollY = e;
			return;
		}
		if (this.scrollDirection === -1 && e <= t) {
			this.setScrollDirection(1), setTimeout(() => {
				this.setScrollDirection(0);
			}, 250), this.lastScrollY = e;
			return;
		}
		if (e <= t) {
			this.setScrollDirection(0), this.lastScrollY = e;
			return;
		}
		Math.abs(e - this.lastScrollY) < 5 || (e >= this.lastScrollY ? this.setScrollDirection(1) : this.setScrollDirection(-1), this.lastScrollY = e);
	}
};
window.customElements.define("main-header", n);
//#endregion
export { n as MainHeader };
